import { render, staticRenderFns } from "./LandingSlideWork.vue?vue&type=template&id=5bd07fd2&lang=pug&"
import script from "./LandingSlideWork.vue?vue&type=script&lang=js&"
export * from "./LandingSlideWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports